const SESSION_STORAGE = 'sessionStorage';
const LOCAL_STORAGE = 'localStorage';
const getItem = (storage) => (key) => {
    let item = null;
    try {
        item = window[storage].getItem(key);
        if (item) {
            return JSON.parse(item);
        }
        return item;
    }
    catch {
        return item;
    }
};
const isStringifyNeeded = (value) => {
    return (toString.call(value).includes('Object') ||
        toString.call(value).includes('Array'));
};
const setItem = (storage) => (key, value) => {
    try {
        let storageValue;
        if (isStringifyNeeded(value)) {
            storageValue = JSON.stringify(value);
        }
        else if (typeof value === 'string') {
            storageValue = value;
        }
        else {
            storageValue = String(value);
        }
        window[storage].setItem(key, storageValue);
    }
    catch { }
};
const removeItem = (storage) => (key) => {
    try {
        window[storage].removeItem(key);
    }
    catch { }
};
const storage = {
    session: {
        getItem: getItem(SESSION_STORAGE),
        setItem: setItem(SESSION_STORAGE),
        removeItem: removeItem(SESSION_STORAGE),
    },
    local: {
        getItem: getItem(LOCAL_STORAGE),
        setItem: setItem(LOCAL_STORAGE),
        removeItem: removeItem(LOCAL_STORAGE),
    },
};

export { storage };
//# sourceMappingURL=storageWrapper.js.map
